const MainTipos = {
    data: {
        ERROR: 100,
        OBTENER_DATOS_PERSONA: 25,
        OBTENER_REFERENCIA_BANCARIA: 26,
        VALIDADOR_API_PERSONA: 40,
        VALIDADOR_API_REF_BANCARIA: 41,
        CAMPANA_PENDIENTE: 801,
        CAMPANA_EXITOSA: 802,
        CAMPANA_ERORR: 804,
        GUARDAR_TRACKID: 98867855,
        MOSTRAR_MODAL_ERROR_GENERICO: 17867835,
        GUARDAR_EMAIL_SOCIO: 34567890987654567,
        GUARDAR_TOKEN_SOCIO: 57603182377,
        GUARDAR_FECHA_SERVIDOR: 9573729291241457,
        GUARDAR_IDFLUJO: 56573712363,
        fecha: {
            INICIO_FECHA_SERVIDOR: 746123134322,
            OBTENER_FECHA_SERVIDOR: 574839103845,
            ERROR: 9764833384574509
        },
        indicadorCurse: {
            INICIO_INDICADOR_CURSE: 98381231,
            OBTENER_INDICADOR_CURSE: 463718234,
            ERROR: 12334567123
        },
        consultarDellateSolicitud: {
            INICIO_CONSULTAR_DETALLE_SOLICITUD: 3231235,
            OBTENER_CONSULTAR_DETALLE_SOLICITUD: 14378100043,
            ERROR: 324512345
        },
        simulacion: {
            INCION_SIMULAR: "INCION_SIMULAR",
            OBTENER_SIMULACION: "OBTENER_SIMULACION",
            ERROR_CODE:"ERROR_CODE",
            ERROR: "ERROR"
        },
        solicitar: {
            INCION_SOLICITAR: "INCION_SIMULAR",
            OBTENER_SOLICITAR: "OBTENER_SOLICITAR",
            ERROR: "ERROR"
        },
        enviarSolicitud: {
            ARCHIVO_ENVIANDO: "ARCHIVO_ENVIANDO",
            ARCHIVO_ENVIADO: "ARCHIVO_ENVIADO",
            ERROR: "ERROR"
        },
        updatePersona: {
            API_UPDATE_PERONA:"API_UPDATE_PERONA",
            UPDATE_PERONA:"UPDATE_PERONA",
            ERROR:"ERROR"
        },
        webViuw:{
            SET_WEBVIUW:'SET_WEBVIUW'
        }
    },
    session: {
        ACTUALIZAR_TRACKID_SESSION: "ACTUALIZAR_TRACKID_SESSION",
        GUARDAR_TOKEN_SOCIO_SESSION: "GUARDAR_TOKEN_SOCIO_SESSION",
        ID_FLUJO_SESSION: "ID_FLUJO_SESSION",
        REFRES_TOKEN:"REFRES_TOKEN"
    }
}

export default MainTipos;